<template>
    <div style="width: 100%" class="mt-4">
        <label>
            <input type="checkbox" value="1"
                   id="inspections_only" v-model="checked">
            {{ label }}
        </label>

        <input :id="name" v-model="valueChecked" :name="name" type="hidden">
    </div>
</template>

<script>

export default {
    name: "CheckboxComponent",
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value: {
            required: false
        },
    },
    data() {
        return {
            checked: false,
            valueChecked: 0
        }
    },
    watch: {
        checked(val) {
            this.valueChecked = val ? 1 : 0;
            let app = this;
            this.$emit('change', val);
            setTimeout(function () {
                $('#' + app.name).trigger('change');
            }, 100)
        },
    },
    mounted() {
        this.checked = parseInt(this.value) === 1;
        this.$forceUpdate()
        let app = this;
        setTimeout(function () {
            $('#' + app.name).trigger('change');
        }, 500)

    },
}
</script>

<style scoped>

</style>
